import React, { useState, useEffect } from "react";
import styles from "./Footer.module.css";
import { useNavigate } from "react-router-dom";
import * as PublicApi from "../../../service/publicApi";
import Logo_minitry from "../../../asset/image/logo-minisrty.png";
import Logo_medical from "../../../asset/image/logo-Medical_Sciences.png";
import Logo_sor from "../../../asset/image/logo-sor-gor-sor-vor.png";
import Logo_mlsi from "../../../asset/image/logo-mlsi.png";

const Footer = (props) => {
  const [rating, setRating] = useState(0);

  const { hide_menu } = props;

  useEffect(() => {
    fetchGuidelines();
  }, []);

  const fetchGuidelines = async () => {
    let res = await PublicApi.getQuestionnaire();

    if (res) {
      if (res["data"]["code"] === 200) {
        setRating(res["data"]["rating"]["rating"]);
      }
    }
  };

  const navigate = useNavigate();
  const menuClick = (menu) => {
    if (menu === "home") {
      navigate("/");
    } else if (menu === "about") {
      navigate("/about");
    } else if (menu === "information") {
      navigate("/information");
    } else if (menu === "contact") {
      navigate("/contact");
    } else if (menu === "login") {
      navigate("/login");
    } else if (menu === "register") {
      navigate("/register");
    } else if (menu === "ansQandA") {
      navigate("/ansQandA");
    } else if (menu === "usagePolicy") {
      navigate("/usagePolicy", { state: "policy" });
    } else if (menu === "Requirements") {
      navigate("/usagePolicy", { state: "requirements" });
    } else if (menu === "termsService") {
      navigate("/termsService");
    }
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        <div className={styles.layoutList}>
          <div>
            <div style={{ display: 'flex', padding: '50px 0px 10px 0px', flexWrap: 'wrap', background: '#FFFFFF', gap: '1.5rem' }}>
              <img
                className={styles.logo}
                src={require("../../../asset/image/logo.svg").default}
                alt="Logo"
              />
              <img className={styles.logo} src={Logo_minitry} alt="Logo" />
              <img className={styles.logo} src={Logo_medical} alt="Logo" />
              <img className={styles.logo} src={Logo_mlsi} alt="Logo" />
              <img className={styles.logo} src={Logo_sor} alt="Logo" />
            </div>
            <h1 className={styles.title}>
              สถาบันชีววิทยาศาสตร์ทางการแพทย์ กรมวิทยาศาสตร์การแพทย์
            </h1>
            <p>
              88/7 ซอยบำราศนราดูร ต.ตลาดขวัญ อ.เมือง จ.นนทบุรี 11000
              <br className={styles.br} />
              Department of Medical Sciences, Ministry of Public Health,
              Tivanond Road, Nonthaburi 11000, Thailand
              <br className={styles.br} />
              โทรศัพท์: 0-2589-9850 ถึง 8 ต่อ 98096
              <br className={styles.br} />
              ศูนย์เทคโนโลยีสารสนเทศและการสื่อสาร กรมวิทยาศาสตร์การแพทย์ E-mail:
              itc.all@dmsc.mail.go.th
            </p>
            {!hide_menu && (
              <>
                <div className={styles.links}>
                  <a href="/">หน้าแรก</a>
                  <a href="/news">ประชาสัมพันธ์</a>
                  <a href="/about">เกี่ยวกับเรา</a>
                  <a href="/information">ข้อมูลที่เกี่ยวข้อง</a>
                </div>
              </>
            )}
          </div>
          <div
            className={`${styles.rating} cursor-pointer`}
            onClick={() => navigate("/questionnaire")}
          >
            <div className={styles.ratingChild}>
              <p>
                ระดับความพึงพอใจของผู้ใช้งาน{" "}
                {Number(rating !== "NaN" ? rating : 0).toFixed(1) || 0}
                /5.0
              </p>
              <div className={styles.stars}>
                {Array.from({ length: 5 }, (_, index) => (
                  <span
                    key={index}
                    style={{
                      color:
                        index <
                        Math.round(Number(rating !== "NaN" ? rating : 0))
                          ? "#FFD700"
                          : "#DEDEDE",
                    }}
                  >
                    ★
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className={styles.bottomFooter}>
        <span>Copyright © 2024 DMSC. All Rights Reserved.</span>
        <span className={styles.separator}>|</span>
        {!hide_menu && (
          <>
            <span
              className={`${styles.footerLink} cursor-pointer`}
              onClick={() => menuClick("termsService")}
            >
              เงื่อนไขการให้บริการ
            </span>
            <span className={styles.separator}>|</span>
            <span
              className={`${styles.footerLink} cursor-pointer`}
              onClick={() => menuClick("usagePolicy")}
            >
              นโยบายความเป็นส่วนตัว
            </span>
            <span className={styles.separator}>|</span>
            <span
              className={`${styles.footerLink} cursor-pointer`}
              onClick={() => menuClick("Requirements")}
            >
              ข้อกำหนดและนโยบายการใช้งาน
            </span>
          </>
        )}
      </div>
    </footer>
  );
};

export default Footer;
